module.exports = __webpack_public_path__ + "public/hws/images/background.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/hws/images/background.jpg
// module id = 314
// module chunks = 0